/*global angular,env */
'use strict';

angular.module('MrDWebApp').controller('ProfileCtrl', function ($scope, $rootScope, loginFactory, $http, profile, userFactory, $window, $cookies, storage, $state, $previousState, $stateParams) {

  var _profile = this;

  $scope._rc.bodyClass = 'html-profile';

  _profile.isWorking = false;
  _profile.requestData = false;
  _profile.message = '';

  _profile.profile = profile;

  if ($stateParams.view === 'cards') {
    $scope._rc.showCards(null, 'all');
  }

  $previousState.memo('caller');

  // // The app.js router 'detector' has already stored the state, but if it hasn't
  if ($previousState.get('caller').state !== null) {
    $previousState.memo('caller'); // Always Memo the Caller
  }
  if ($previousState.get('caller').state && $previousState.get('caller').state.name !== 'checkout') {
    //console.log('caller - not checkout - save..');
    $previousState.memo('caller');
  }

  _profile.closeEditAccount = function () {

    if ($previousState.get('caller').state !== null) { // <- BROKEN GOOD
      $previousState.go('caller');
    } else {
      if (window.env.domainSplit) window.location.href = '/'; else $state.go('home');
    }

  };

  $http.get('/api/seohost').then(function (res) {
    if (res.data && (res.data.length || res.data.length === 0 || !res.data.success)) { //string or array or unsuccessful
      console.log('Unexpected response form /seohost');
      return;
    }
    _profile.sharehost = res.data.data;
  }).catch(function () {
    console.log('Error response form /seohost');
  });

  _profile.sendPOPIDataRequest = function () {
    _profile.isWorking = true;
    $http.post(env.apiURL + 'v3/users/' + $scope._rc.access.user.id + '/dsar', {
      'type': 'request_all_my_data'
    }).then(function (res) {
      if (res.status === 200) {
        _profile.requestData = true;
      }
      _profile.isWorking = false;
    }).catch(function (res) {
      console.error('There was an error', res);
    });
  };

  _profile.sendPOPIDataDelete = function () {
    _profile.isWorking = true;
    $http.post(env.apiURL + 'v3/users/' + $scope._rc.access.user.id + '/dsar', {
      'type': 'delete_all_my_data'
    }).then(function (res) {
      if (res.status === 200) {
        _profile.requestData = true;
      }
      _profile.isWorking = false;
    }).catch(function (res) {
      console.error('There was an error', res);
    });
  };

  _profile.updateAccount = function () { //email/password
    _profile.isWorking = true;
    _profile.message = '';

    // $scope._rc.access.user.name = _profile.email;
    // $scope._rc.access.user.profile.email = _profile.email;
    _profile.profile = {
      profile: {}
    };
    _profile.profile.name = _profile.email;
    _profile.profile.profile.email = _profile.email;
    _profile.profile.password = _profile.password;

    loginFactory.updateAccount($scope._rc.access.user.id, _profile.profile,
      function () {

        $window.scroll(0, 0);
        _profile.isWorking = false;
        _profile.message = '<span class="success">Changes Saved!</span>';
        var auth = btoa(_profile.profile.name + ':' + _profile.profile.password);
        var basic_profile_encoded = 'Basic ' + auth;
        $http.defaults.headers.common.Authorization = basic_profile_encoded; // Resave This.
        $scope._rc.access.auth = basic_profile_encoded;
        $scope._rc.access.user.name = _profile.profile.name;
        $scope._rc.access.user.profile.email = _profile.profile.name;
        storage.set('mrd-web-access', $scope._rc.access);

        $scope._rc.shareSession(auth, _profile.sharehost);

        window.Raven.setUserContext({
          id: $scope._rc.access.user.id,
          email: $scope._rc.access.user.profile.email
        });

      }, function () {

        $window.scroll(0, 0);
        _profile.isWorking = false;
        _profile.message = '<span class="success failure">Failed to save</span>';

      });

    // Resetup
    //var basic_profile_encoded = 'Basic ' + btoa(_profile.email + ':' + _profile.password);
    // $scope._rc.access.auth = basic_profile_encoded;
    // $scope._rc.access.user.name = response.name;
    // $scope._rc.access.user.profile = response.profile;


  };

  _profile.update = function () {

    _profile.isWorking = true;

    userFactory.update({ userID: $scope._rc.access.user.id }, _profile.profile,
      function () {

        $window.scroll(0, 0);
        _profile.isWorking = false;
        _profile.message = '<span class="success">Changes Saved!</span>';

        $scope._rc.access.user.profile = _profile.profile.profile;
        storage.set('mrd-web-access', $scope._rc.access);


      }, function () {

        $window.scroll(0, 0);
        _profile.isWorking = false;
        _profile.message = '<span class="success failure">Failed to save</span>';

      });
  };

});
